import { FuelTypography } from '@frete.com/fuel-react';
import { useState } from 'react';
import { Grid, Tabs } from '~components';
import CompanyTypeCooperativeSa from '../CompanyTypeCooperativeSa';
import CompanyTypeMeiLtda from '../CompanyTypeMeiLtda';
import { Container } from './styled';
import { TTabStatus } from './types';

function CompanyTypeInformation() {
  const [pageSection, setPageSection] = useState<TTabStatus>(
    TTabStatus.MEI_LTDA
  );

  return (
    <>
      <Container>
        <Grid container direction="column" spacing={5}>
          <Grid>
            <FuelTypography size="heading-sm" weight="bold">
              Qual o seu tipo de empresa?
            </FuelTypography>
          </Grid>
          <Grid>
            <Tabs
              options={[
                {
                  id: 'mei-ltda',
                  label: 'MEI e LTDA',
                },
                {
                  id: 'cooperative-sa',
                  label: 'Cooperativa e SA',
                },
              ]}
              value={pageSection}
              onChange={(value: TTabStatus) => setPageSection(value)}
            />
          </Grid>
          <Grid container direction="column" spacing={12}>
            {pageSection === TTabStatus.MEI_LTDA && <CompanyTypeMeiLtda />}
            {pageSection === TTabStatus.COOPERATIVE_SA && (
              <CompanyTypeCooperativeSa />
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default CompanyTypeInformation;
